import React,{useEffect} from "react"
import NavigationItem from "./NavigationItem/NavigationItem"
import PropTypes from "prop-types"
import * as styles from "./Navigation-tw-styles"


const Navigation = ({ navigation, variant, language, isActive}) => {
  const style =  styles[variant] || styles.defaultStyle
  const { navContainer } = style

  return (
    <ul className={navContainer}>
      {navigation?.length > 0 &&
        navigation.map((item, index) => {
          return(<NavigationItem item={item} key={index} isActive={item?.link?.scrollToElementId == isActive ? "text-[#2D6EAA] underline" : ""} variant={variant} language={language}/>)
        })}
    </ul>
  )
}

Navigation.propTypes = {
  navigation: PropTypes.array,
  variant: PropTypes.string,
  language: PropTypes.string,
  isActive: PropTypes.string
}

export default Navigation
